<template>
  <transition :name="!scrollUp ? 'firstBar' : 'firstBar-reverse'">
    <section
      v-show="isActive"
      class="first-bar"
      :style="{
        backgroundImage:
          'url(' + require('@/assets/lifestyle-page/bg-firstBar.jpg') + ')',
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat'
      }"
    >
      <div class="cloud">
        <img :src="require('@/assets/lifestyle-page/cloud.png')" alt="cloud" />
      </div>
      <div class="grid">
        <template v-for="(item, index) in list" :key="item.id">
          <router-link
            :to="
              $i18nRoute({
                name: 'NewsDetail',
                params: { slug: item.url }
              })
            "
            class="grid__item"
          >
            <transition
              v-show="isActive"
              :name="!scrollUp ? 'scale-card' : 'scale-card-reverse'"
            >
              <div class="card" :class="`card-${index + 1}`">
                <div class="card__img">
                  <div class="card__category-img">
                    {{ item.sub_category.name }}
                  </div>
                  <ImageContainer
                    class="img"
                    :src="item.image.medium"
                    :thumb="item.image.thumbnail"
                    :alt="item.title"
                  />
                </div>
                <div class="card__descr">
                  <div class="card__title limited-text">
                    {{ item.title }}
                  </div>
                  <div class="data-news">
                    <span class="day">{{ handleDate(item.pub_date) }},</span>
                    <span class="time">{{ handleTime(item.pub_date) }}</span>
                  </div>
                </div>
              </div>
            </transition>
          </router-link>
        </template>
      </div>
    </section>
  </transition>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    },
    scrollUp: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style scoped lang="scss">
.first-bar {
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;

  @media screen and (max-width: 992px) {
    position: relative;
  }
}

.card {
  color: #4f4f4f;
  &__category-img {
    color: rgba(79, 79, 79, 0.7);
  }
}
.grid {
  height: 100vh;
  max-width: 85%;
  padding-top: 6rem;
  margin-left: auto;
  margin-right: auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  position: relative;
  .grid__item:nth-child(1) {
    align-self: center;
  }

  .grid__item:nth-child(2) {
    align-self: flex-end;
    grid-column: 2 / span 1;
  }
  .grid__item:nth-child(3) {
    align-self: center;
    grid-column: 3 / span 2;
  }
  .grid__item:nth-child(5) {
    grid-column: 2 / span 3;
  }
}

.card-1 {
  width: 18vw;

  .card__img {
    position: relative;
    .img {
      margin-top: 1rem;
      height: 15vw;
      clip-path: url("#cardFirstClip");
    }
  }
  .card__category-img {
    position: absolute;
    left: 30%;
    z-index: 2;
    top: -7px;
  }
  .card__descr {
    margin-top: 2rem;
  }
}
.card-2 {
  margin-top: 8rem;
  width: 18vw;
  margin-left: 10%;

  .card__img {
    // height: 280px;
    position: relative;
    .img {
      height: 25vh;
      // padding-bottom: 80%;
      clip-path: url("#cardSecondClip");
    }
  }
  .card__category-img {
    position: absolute;
    left: 20%;
    z-index: 2;
    top: 5px;
  }
  .card__descr {
    margin-top: 2rem;
  }
}
.card-3 {
  width: 20vw;
  margin-left: auto;
  margin-right: 5em;
  .card__img {
    position: relative;
    .img {
      padding-bottom: 90%;
      clip-path: url("#cardThirdClip");
    }
  }
  .card__descr {
    width: 95%;
    margin-left: 40px;
  }
  .card__category-img {
    position: absolute;
    left: 40%;
    z-index: 2;
    top: 5px;
  }
}
.card-4 {
  max-width: 17vw;
  .card__img {
    // height: 280px;
    position: relative;
    .img {
      height: 25vh;
      clip-path: url("#cardFourthClip");
    }
  }
  .card__category-img {
    position: absolute;
    right: 16%;
    z-index: 2;
    top: 5px;
  }
}

.card-5 {
  margin-top: 2rem;
  max-width: 100%;
  display: flex;
  margin-left: 30%;
  transition: all 1s !important;

  .card__img {
    position: relative;
    // max-width: 390px;
    flex: 0 0 40%;
    height: 34vh;
    .img {
      height: 100%;
      clip-path: url("#cardFivthClip");
    }
  }
  .card__category-img {
    position: absolute;
    right: 45%;
    z-index: 2;
    top: 0px;
  }
  .card__descr {
    display: flex;
    gap: 1rem;
    flex-direction: column;
    justify-content: center;
  }
}
@media screen and (max-width: 1500px) {
  .grid {
    max-width: 95%;
    &__item:nth-child(1) {
      align-self: start !important;
    }
    &__item:nth-child(3) {
      align-self: start !important;
    }
  }
  .card-3 {
    max-width: 70%;
    .card__img {
      // height: 10vw;
      .img {
        padding-bottom: 70%;
      }
    }
  }
  .card-1,
  .card-3 {
    width: 100%;
    margin-top: 5rem;
  }
  .card-2 {
    width: 75%;
    margin: 0 auto;
  }
  .card-4,
  .card-5 {
    max-width: 100%;
  }
  .card-5 {
    .card__img {
      flex: 0 0 50%;
    }
  }
}
.cloud {
  display: none;
  position: absolute;
  top: -11%;
  left: -5%;
  width: 110%;
  height: auto;
  z-index: 0;
  img {
    width: 100%;
    height: 100%;
    background: transparent;
  }
}

/* ----------- iPad Pro ----------- */
/* Portrait and Landscape */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
}

/* Portrait */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
  .grid {
    grid-template-rows: repeat(3, 1fr);
    height: 85% !important;
    margin-top: 9rem;
    margin-bottom: auto;
    padding: 0;
    &__item:nth-child(1) {
      grid-column: 1 / span 2;
    }
    &__item:nth-child(2) {
      grid-column: 3 / span 2 !important;
    }
    &__item:nth-child(3) {
      grid-column: 1 / span 4 !important;
      align-self: center;
    }
    &__item:nth-child(4) {
      grid-column: 1 / span 2 !important;
    }
    &__item:nth-child(5) {
      grid-column: 3 / span 2 !important;
    }
  }

  .card-1 {
    .card__category-img {
      left: 30%;
      top: -9px;
    }
  }
  .card-2 {
    .card__category-img {
      left: 25%;
      top: 0px;
    }
  }
  .card-2,
  .card-1 {
    width: 90%;

    .card__img {
      .img {
        height: auto;
        padding-bottom: 66%;
      }
    }
  }
  .card-3 {
    display: flex;
    align-items: center;
    max-width: 100%;
    width: 90%;
    margin: 0 auto;
    .card__img {
      flex: 0 0 40%;
      .img {
        padding-bottom: 66%;
      }
    }
  }
  .card-4 {
    max-width: 100%;
    width: 90%;
  }
  .card-5 {
    width: 90%;
    margin-top: 0;
    margin-left: auto;
    flex-direction: column;
    align-items: stretch;

    .card__img {
      .img {
        height: auto;
        padding-bottom: 66%;
      }
    }
  }
}

/* Landscape */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1.5) {
  .grid {
    padding-top: 3rem;
  }
  .card-5 {
    width: 80%;
    margin-top: 10%;
    margin-left: auto;
    .card__img {
      .img {
        height: 80%;
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .grid {
    padding: 2rem 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: auto;
    align-self: flex-start !important;
    &__item {
      width: 100%;
    }
    &__item:nth-child(1) {
      order: 2;
    }
    &__item:nth-child(2) {
      order: 1;
    }
    &__item:nth-child(3) {
      order: 3;
    }
    &__item:nth-child(4) {
      order: 4;
    }
    &__item:nth-child(5) {
      order: 5;
    }
  }
  .first-bar {
    height: auto;
  }
  .card {
    display: flex;
    margin: 0;
    width: 100%;
    align-items: center;
    gap: 1rem;
    &__img {
      flex: 0 0 50% !important;
      height: auto !important;
      .img {
        height: auto !important;
        padding-bottom: 70%;
      }
    }
  }
  .card-1 {
    .card__img {
      order: 2;
    }
  }
  .card-3 {
    .card__descr {
      margin-left: 0;
    }
  }
  .card-4 {
    .card__img {
      order: 2;
    }
  }
  .cloud {
    display: block;
  }
}

@media screen and (max-width: 767px) {
  .card {
    &__title {
      font-size: 14px !important;
    }
    .card__category-img {
      font-size: 12px;
    }
  }
  .card-1 {
    .card__category-img {
      top: 2%;
    }
  }
  .card-2 {
    .card__category-img {
      top: -2%;
      left: 11%;
    }
  }
  .card-3 {
    max-width: 100%;
    .card__category-img {
      left: 10%;
      top: -3%;
    }
  }
  .card-4 {
    .card__category-img {
      right: 6%;
      top: 0;
    }
  }
  .card-5 {
    .card__category-img {
      top: -2%;
      left: 40%;
    }
  }
}

.scale-card-enter-active {
  transition: all 1s !important;
}
.scale-card-enter-from {
  animation: scale-card-animation 1s;
}
.scale-card-enter-to {
  animation: scale-card-animation 1s;
}

.scale-card-leave-active {
  transition: all 1s !important;
}
.scale-card-leave-from {
}
.scale-card-leave-to {
}

.firstBar-enter-active,
.firstBar-leave-active {
  transition: all 0.6s;
}
.firstBar-leave-from {
  transform: translateY(0);
}
.firstBar-leave-to {
  transform: translateY(-100%);
}

.firstBar-reverse-leave-active {
  transition: all 1s;
}
.firstBar-reverse-enter-active {
  transition: all 0.6s;
}

.firstBar-reverse-enter-from {
  transform: translateY(-100%);
}

.firstBar-reverse-leave-to {
}

.scale-card-reverse-leave-active,
.scale-card-reverse-enter-active {
  transition: all 0.8s;
}

.scale-card-reverse-enter-to {
}
.scale-card-reverse-enter-from {
}
.scale-card-reverse-leave-to {
  animation: scale-card-animation 1s reverse;
}
.scale-card-reverse-leave-from {
}
</style>

<style lang="scss">
@keyframes scale-card-animation {
  0% {
    transform: scale(0.4);
  }
  50% {
    transform: scale(0.7);
  }
  100% {
    transform: scale(1);
  }
}
</style>
